import { formatMoney } from 'accounting'

import { Box, Text } from '@domain-group/suit-theme'

const TotalsListItem = (props: { label: string, value: number}) => {
  const { label, value } = props

  return (
    <Box alignItems="center" justifyContent="flex-end" marginBottom="large">
      <Text color="bodyFontLightColor" fontSize="xsmall">
        {label}
      </Text>

      <Text fontSize="small" textAlign="right" width={100}>
        {formatMoney(value)}
      </Text>
    </Box>
  )
}

export default TotalsListItem
